import { useEffect, useState } from 'react';
import { Tag } from 'react-feather';
import { WeeklyColumnsGrid } from '../../components/grid/Grid';
import { useWeeksThatFit } from '../../components/grid/useWeeksThatFit';
import NuggetCategoryFilter from './NuggetCategoryDropdown';
import { Nugget, categoryKeys } from './types';
import { daysAgo, getDayMonthYearFromDate } from '../../util/dateTime';

const ExtractedNuggets = (props: {
  nuggets: Nugget[];
  loading: boolean;
  setShowPremiumModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { nuggets, loading, setShowPremiumModal } = props;
  const [categoryIndex, setCategoryIndex] = useState(0);
  const [gridContainer, setGridContainer] = useState<HTMLDivElement | null>(null);
  const weeksToDisplay = useWeeksThatFit(gridContainer);
  const [range, setRange] = useState({
    start: getDayMonthYearFromDate(daysAgo(7 * weeksToDisplay)),
    end: getDayMonthYearFromDate(new Date())
  });

  // Widening the window shows more weeks, so the range has to grow with it.
  useEffect(() => {
    setRange({
      start: getDayMonthYearFromDate(daysAgo(7 * weeksToDisplay)),
      end: getDayMonthYearFromDate(new Date())
    });
  }, [weeksToDisplay]);
  return (
    <div className="tw-flex tw-flex-col tw-w-full tw-gap-6 tw-rounded-3xl tw-border-2 tw-border-solid tw-border-neutral-100 tw-bg-white tw-p-5 lg:tw-p-6">
      <div className="tw-flex tw-flex-col tw-gap-4 sm:tw-flex-row sm:tw-justify-between sm:tw-items-center">
        <h2 className="tw-m-0 tw-flex tw-items-center tw-gap-2 tw-font-light tw-text-xl lg:tw-text-2xl tw-text-neutral-800">
          <Tag className="tw-w-6 tw-h-6 tw-shrink-0" />
          Extracted Nuggets
        </h2>
        {!loading && (
          <NuggetCategoryFilter
            categoryIndex={categoryIndex}
            setCategoryIndex={setCategoryIndex}
            setShowPremiumModal={setShowPremiumModal}
          />
        )}
      </div>
      {/* The ref sits on an element that renders in both states, so the grid
          knows how wide it may be before the nuggets have arrived. */}
      <div ref={setGridContainer} className="tw-w-full tw-overflow-x-auto">
        {loading ? (
          <div className="tw-flex tw-justify-center tw-items-center">
            <span className="tw-h-20 tw-w-20 spinner-border" role="status" aria-hidden="true"></span>
          </div>
        ) : (
          <div className="tw-min-w-fit">
            <WeeklyColumnsGrid
              tagFilter={[]}
              gridValues={nuggets.filter((nug) => nug.category === categoryKeys[categoryIndex])}
              range={range}
              setRange={setRange}
              weeksToDisplay={weeksToDisplay}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExtractedNuggets;
